const RELATIVE_DATE_VALUES = {
    TODAY: 'TODAY',
    MTD: 'MTD',
    YTD: 'YTD'
} as const;

export default RELATIVE_DATE_VALUES;
